// Modules
import * as React from "react";

// Style
import "./serviceTemplate.scss";

// Components
import Subscription from "src/components/Organisms/Subscription/subscription";
import ServiceCard from "src/components/Organisms/ServiceBox/serviceCard";
import { Location } from '@reach/router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { t } from "i18next";


// Interfaces
import { IServiceItem } from "src/Interfaces/interfaces";
import Hero, { IHeroProps } from "src/components/Organisms/Hero/hero";

interface IServiceTemplateProps {
    hero: IHeroProps;
    serviceList: IServiceItem[];
    lgString?: string;
    // location?: any;
}
interface IProps extends WithTranslation {
    prop: any;
  }
  
  interface IState {
    state: any;
  }


class ServiceTemplate extends React.PureComponent<
    IServiceTemplateProps,IProps , IState
> {
    public render() {
        return (
            <>
                {/* <h1>{this.props.location.pathname}</h1> */}
                <Hero {...this.props.hero} />
                <div className="container-fluid section-padding-tb96">
                    <div className="container">
                        <h2 className="section-header all-cap">
                            {t(`serviceTemplate.title`)}
                            <bdi className="section-header all-cap text-highlight">
                                {" "}
                                {t(`serviceTemplate.description`)}
                            </bdi>
                        </h2>
                        <div className="row">
                            {this.props.serviceList.map(service => (
                                <ServiceCard {...service} lgString={this.props.lgString}/>
                            ))}
                        </div>
                    </div>
                </div>
                <Subscription />
            </>
        );
    }
}
export default withTranslation('info')(ServiceTemplate)